import { Component, OnInit ,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { GlobalService } from '../global.service';
import { MatDialog, MatDialogConfig,MAT_DIALOG_DATA  } from '@angular/material';
import { Subscription } from "rxjs";
import { PostpaidComponent } from './components/postpaid/postpaid.component';
import { PrepaidComponent } from './components/prepaid/prepaid.component';
import { FixedComponent } from './components/fixed/fixed.component';
import { PopupGiftAcceptedComponent } from '../components/gift-receiver/components/popup-gift-accepted/popup-gift-accepted.component';
import { PopupGiftExpiredComponent } from '../components/gift-receiver/components/popup-gift-expired/popup-gift-expired.component';
import { PopupQuestionComponent } from './components/popup-question/popup-question.component';
import { AngularFireAnalytics } from '@angular/fire/analytics';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {
  //cambios
  @ViewChild(PostpaidComponent,{static: false}) postpaidComp: PostpaidComponent;
  @ViewChild(FixedComponent,{static: false}) fixedComp: FixedComponent;
  @ViewChild(PrepaidComponent,{static: false}) prepaidComp: PrepaidComponent;
  public tabActive='Dashboard';
  public selectBan;
  public currentList;
  public postpago=false;
  public prepago=false;
  public telefoniaFijo=false;
  public totalAccountList;
  public viewPaper=1;
  public showUserMobile = true;
  public billDueDateField;
  public billDateField;
  public lastPaymentAmountField;
  public billBalanceField;
  public paperless;
  public accountType;
  public accountSubtype;
  public type;
  public popPreguntasSeguridad;
  public token:string=sessionStorage.getItem("token");
  public subscribers;
  public subscriber;
  public prepaidBalance=0;
  public endDateField='N/A';
  loadObserver: Subscription;
  initialize: Subscription;
  public giftMessage = '';
  public nameSend;
  public gui;
  public cr='';
  public optionTemplete:string='';
  constructor(private router:Router,public appComponent:AppComponent,private services: Service,private loadingScreenService:LoadingScreenService,public global:GlobalService, public dialog:MatDialog,public AngularFireAnalytics:AngularFireAnalytics){
    this.AngularFireAnalytics.setCurrentScreen("Dashboard");
    this.AngularFireAnalytics.logEvent("Dashboard-Screenview");
  }

  ngOnInit() {
    this.billBalanceField="0";
    this.global.validateSession();
    this.loadObserver = this.global.loadObserver.subscribe((value:number) => {
      this.dataLoading(value)
    });
    this.initialize = this.global.initialize.subscribe((value:number) => {
      this.initializeData();
    });
    this.selectBan=atob(sessionStorage.getItem("selectBan"));
    this.nameSend = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.firstNameField + ' ' + JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.lastNameField;
    this.lastPaymentAmountField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.lastPaymentAmountField;

    this.billBalanceField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
    if(this.billBalanceField.search('CR')>-1){
      this.cr='CR';
      this.billBalanceField=parseFloat(this.billBalanceField);
    }
    else{
      this.cr='';
    }
    this.billDueDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDueDateField;
    this.billDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDateField;
    this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
    this.accountType= JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountTypeField;
    this.accountSubtype= JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountSubtypeField;
    this.endDateField= JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].planInfoField.endDateField;
    this.subscribers=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
    this.subscriber=this.subscribers[0].subscriberNumberField;
    sessionStorage.setItem("defaultSubscriber", btoa(this.subscriber));//para prepago
    this.popPreguntasSeguridad=JSON.parse(atob(sessionStorage.getItem("popPreguntasSeguridad")));

  }

  ngAfterViewInit(){
    if(this.prepago==true){
      /*
      this.services.updateToken(this.token,btoa(this.selectBan),this.subscriber).subscribe(data =>{
        if(data.hasError==false){
          sessionStorage.setItem("idCustomerCard",btoa(JSON.stringify(data.response)));
          localStorage.setItem("idCustomerCardExt", btoa(JSON.stringify(data.response)));
          this.GetGift1GBSendData();
        }
        else{
          this.GetGift1GBSendData();
          //mensaje que no se genero el token
        }
      });
      */
      this.GetGift1GBSendData();
    }
    else{
      this.GetGift1GBSendData();
    }
    if(this.popPreguntasSeguridad==true){
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      this.dialog.open(PopupQuestionComponent, dialogConfig);
    }
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
  refreshDataTo(event:Event) {
    let index =parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan",btoa(ban));
    this.initializeData();
  }
  dataLoading(sw){
    if(this.global.validateSession()===true){
      this.selectBan=atob(sessionStorage.getItem("selectBan"));
      this.lastPaymentAmountField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.lastPaymentAmountField;
      if(this.prepago==true){
        this.billBalanceField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].prepaidBalanceField;
        sessionStorage.setItem("prepaidBalance",btoa(this.billBalanceField));
      }
      else{
        this.billBalanceField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
      }
      this.accountType= JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountTypeField;
      this.accountSubtype= JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountSubtypeField;
      if(this.billBalanceField.search('CR')>-1){
        this.cr='CR';
        this.billBalanceField=parseFloat(this.billBalanceField);
      }
      else{
        this.cr='';
      }
      this.billDueDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDueDateField;
      this.billDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDateField;
      if(this.postpago==true){
        this.type="postpaid";
        this.postpaidComp.updateCredit(this.selectBan,this.billBalanceField,this.type);
      }
      else if(this.prepago==true){
        this.type="prepaid";
        this.endDateField= JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].planInfoField.endDateField;
        this.subscribers=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo;
        this.subscriber=this.subscribers[0].subscriberNumberField;
        sessionStorage.setItem("defaultSubscriber", btoa(this.subscriber));
        this.prepaidComp.updateCredit(this.selectBan,this.billBalanceField,this.type);
      }
      else if(this.telefoniaFijo==true){
        this.type="fixed";
        this.fixedComp.updateCredit(this.selectBan,this.billBalanceField,this.type);
      }
      this.global.showSplahs(this.type);
      this.GetGift1GBSendData();
      ///this.global.suspendedAccount("S");
    }
  }

  ngOnDestroy() {
    this.loadObserver.unsubscribe();
    this.initialize.unsubscribe();
  }
  recibirRegalo(BANReceiver, Message, NameSender, GUI){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {BANReceiver:this.selectBan,Message:Message,NameSender:NameSender,GUI:GUI};
    this.dialog.open(PopupGiftAcceptedComponent, dialogConfig);
    this.loadingScreenService.stopLoading();
    this.giftMessage = Message;
    this.nameSend = NameSender;
    this.gui = GUI;
  }
  GetGift1GBSendData(){
    this.services.getGift1GBSend(this.token, this.selectBan).subscribe(data=>{
    /*  if (vm.runPrepaid === false) {
        this.loadingScreenService.stopLoading();
    }*/
    this.loadingScreenService.stopLoading();
    if (data.HasError === false) {
      if (data.Gift1GBsents.length > 0) {
          for (var i = 0; i < data.Gift1GBsents.length; i++) {
              if (i === 0) {
                  this.recibirRegalo(data.Gift1GBsents[i].BANReceiver,data.Gift1GBsents[i].Message,data.Gift1GBsents[i].NameSender,data.Gift1GBsents[i].GUI);
              }
          }
      }
    }
    else {
      this.global.notif(data.ErrorDesc);
    }
    });
  }
  viewGiftExpired(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    this.dialog.open(PopupGiftExpiredComponent, dialogConfig);
  }
}
